export default __webpack_public_path__ + "static/media/icon-flow.caeebe69.svg";